import {Injectable, inject} from '@angular/core'
import type {CanActivate} from '@angular/router'
import {NavigationService} from '../navigation.service'
import {SigninService} from '../signin.service'
import {LogType, Logger} from '../utils/logger'

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  readonly #signinService = inject(SigninService)
  readonly #navigationService = inject(NavigationService)

  async canActivate(): Promise<boolean> {
    try {
      if (this.#signinService.isAuthenticated()) {
        this.#navigationService.navigateRoot('/home', {
          queryParams: {redirect: true},
        })
        return false
      }
    } catch (error) {
      Logger.log(LogType.error, 'Error checking authentication:', error)
    }

    return true
  }
}
